import { useMutation } from '@tanstack/react-query';
import { makeRequest } from '../../entry-form-v2/data/makeRequest';

export type CodelistHistoryEventType =
	| 'SEARCH_RECORDS'
	| 'CREATE_RECORD'
	| 'UPDATE_RECORD'
	| 'IMPORT_BULK_RECORDS'
	| 'PARTIAL_IMPORT_RECORDS'
	| 'DELETE_RECORDS'
	| 'DELETE_CODELIST'
	| 'EXPORT_RECORDS'
	| 'GET_RECORD'
	| 'GET_RECORD_HISTORY'
	| 'EXPORT_HISTORY_LOG';

export type CodelistHistoryEvent = {
	id: string;
	createdAt: string;
	entityType: string;
	entityId: string;
	eventType: CodelistHistoryEventType;
	projectId: string;
	subject: string;
	metadata?: string;
};
export type ExportCodelistHistoryResponse = {
	events: CodelistHistoryEvent[];
};

const exportCodelistHistory = (args: { projectId: string }) => {
	return makeRequest<ExportCodelistHistoryResponse>({
		method: 'exportCodelistHistory',
		service: 'cde',
		data: {
			projectId: args.projectId
		}
	});
};

export const useExportCodelistHistoryMutation = (args: { projectId: string }) => {
	return useMutation({
		mutationFn: () => exportCodelistHistory(args)
	});
};
